import store from '../../store/index';
import { activate, optimizelyUserContext, optimizelyUserId } from '../optimizely';
import railsAxios from '../railsAxios';
import tagRecordings from '../../tracking/hotjar/tagRecordings';
import redirectTo from './redirectTo';

export default async function beforeEnterPreReg2Ebs(to, from, next) {
  const completed = await store.dispatch('registration/checkReg1Completed');
  if (completed === 'redirect') {
    return;
  }

  const userContext = await optimizelyUserContext();
  const attributes = {
    customer_type: userContext.customer_type,
  };
  const optlyVariation = localStorage.getItem('optlyVariation') || activate('control_or_ebs', optimizelyUserId(), attributes);
  if (optlyVariation !== 'ebs') {
    tagRecordings(['cannot_enter_pre_reg2_ebs']);
    store.dispatch('setBackendErrorMessage');
    redirectTo('/v/pessoal', from.path);
  }

  const accountID = await store.get('account').account_id;
  const ebs = await store.get('registration').ebs;
  if (ebs === null) {
    await railsAxios.post(`/api/ebs_pre_reg2/show/${accountID}`, {});
    await store.dispatch('registration/checkReg1Completed');
  }

  store.dispatch('setAwaitingNavigation', false);

  next();
}
